import React, { FC, useEffect } from 'react';
import { Button, Form, InputNumber, Modal } from 'antd';
import { useForm, useWatch } from 'antd/es/form/Form';
import { DEFAULT_VALUE_1, PRICE_LIMIT } from 'common/config';
import { replaceCommaWithPeriod } from 'common/helpers';
import { IFormValue } from 'common/models';
import { IUser } from 'entities/User/User.models';
import { calculateUserBalance } from 'entities/User/User.helper';

interface IComponentProps {
  open: boolean;
  loading: boolean;
  user: IUser | null;
  onCancel: () => void;
  onSubmit: (value: number, onSuccess: () => void) => void;
}

export const PersonalLimitChangeModal: FC<IComponentProps> = ({ open, loading, user, onCancel, onSubmit }) => {
  const [form] = useForm();
  const balance = useWatch('balance', form);

  useEffect(() => {
    if (!open || !user) {
      return;
    }

    const balance = calculateUserBalance(user);

    form.setFieldValue('balance', balance ? balance.toFixed(2) : null);
  }, [open, user]);

  const handleCancel = () => {
    if (loading) {
      return;
    }

    onCancel();
  };

  const handleSubmit = ({ balance }: IFormValue) => {
    onSubmit(balance, handleCancel);
  };

  return (
    <Modal
      rootClassName="redesign modal"
      width={400}
      centered
      open={open}
      onCancel={handleCancel}
      destroyOnClose
      footer={[
        <Button key="cancel" className="button-sm secondary" onClick={handleCancel} loading={loading}>
          Отмена
        </Button>,
        <Button key="accept" className="button-sm primary" loading={loading} disabled={!balance} onClick={form.submit}>
          Сохранить
        </Button>,
      ]}
    >
      <div className="mb-3 ff-medium fs-m">2. Изменение персонального лимита</div>
      <div className="mb-6 ff-regular fs-xs color-dark-grey">
        Вы можете редактировать только остаток на текущий период — общий лимит изменится автоматически.
      </div>

      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item label="Остаток за период" name="balance">
          <InputNumber
            placeholder="0.00"
            suffix="₽"
            controls={false}
            min={DEFAULT_VALUE_1}
            max={PRICE_LIMIT}
            precision={2}
            parser={replaceCommaWithPeriod}
            formatter={replaceCommaWithPeriod}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
